import { create } from "zustand";

type ImageType = {
    image: File | null,
};
type UserStore = {
    getImg: () => File | null;
    setImage: (img: File | null) => void
}


const usePersonStore = create<ImageType & UserStore>(
    (set, get) => ({
        image: null,
        setImage: (img: File | null) => {
            set((state) => ({ ...state, image: img }));
        },
        getImg: () => get().image
    })
)

export default usePersonStore;



